import { IExercise } from '../../../types/workout/exercise';

function parseRpe(v: number | string | null | undefined): number {
  if (typeof v === 'number') return v;
  return parseFloat(String(v ?? ''));
}

export function rpeTint(v: number | string | null | undefined): string {
  const n = parseRpe(v);
  if (isNaN(n)) return 'var(--pd-fill)';
  if (n <= 6) return 'rgba(163, 230, 53, 0.3)';
  if (n <= 7.5) return 'rgba(163, 230, 53, 0.55)';
  if (n <= 8.5) return 'rgba(249, 115, 22, 0.4)';
  return 'rgba(239, 68, 68, 0.5)';
}

export function rpeInk(v: number | string | null | undefined): string {
  const n = parseRpe(v);
  if (isNaN(n)) return 'var(--pd-ink-3)';
  if (n <= 7.5) return 'var(--pd-lime-ink)';
  if (n <= 8.5) return 'var(--pd-warn-ink)';
  return 'var(--pd-danger-ink)';
}

export function muscleGroupLabel(ex: IExercise | undefined): string {
  if (!ex?.muscles?.length) return '';
  return ex.muscles
    .map((m) => m.muscle?.name)
    .filter((n): n is string => Boolean(n))
    .join(' · ');
}

export function formatSessionTime(value?: string | Date | null): string {
  if (!value) return '';
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d.getTime())) {
      return typeof value === 'string' ? value : '';
    }
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return typeof value === 'string' ? value : '';
  }
}

export function formatCompletedOn(value?: Date | string | null): string {
  if (!value) return '';
  try {
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d.getTime())) return typeof value === 'string' ? value : '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return '';
  }
}

/**
 * Normalize a numeric-string field that may arrive as '0', '' or undefined.
 * Returns null when we should treat the value as "absent".
 */
export function nonEmpty(value: unknown): boolean {
  return value !== null && value !== undefined && value !== '';
}
